import request from '../utils/request'

// 获取菜单列表（分页+模糊查询）
export function getMenuList(data) {
  return request({
    url: '/menu/page',
    method: 'post',
    data
  })
}

// 根据ID获取菜单详情
export function getMenuById(id) {
  return request({
    url: `/menu/${id}`,
    method: 'get'
  })
}

// 根据父级ID获取菜单
export function getMenuByParentId(parentId) {
  return request({
    url: `/menu/parentId/${parentId}`,
    method: 'get'
  })
}

// 根据类型获取菜单
export function getMenuByType(type) {
  return request({
    url: `/menu/type/${type}`,
    method: 'get'
  })
}

// 创建菜单
export function createMenu(data) {
  return request({
    url: '/menu',
    method: 'post',
    data
  })
}

// 更新菜单
export function updateMenu(data) {
  return request({
    url: '/menu',
    method: 'put',
    data
  })
}

// 删除菜单
export function deleteMenu(id) {
  return request({
    url: `/menu/${id}`,
    method: 'delete'
  })
}